module.exports = {
          srcSet: __webpack_public_path__ + "828fce2d440215c808981e68fdb6550a-455.png"+" 455w",
          images:[ {path: __webpack_public_path__ + "828fce2d440215c808981e68fdb6550a-455.png",width: 455,height: 127}],
          src: __webpack_public_path__ + "828fce2d440215c808981e68fdb6550a-455.png",
          toString:function(){return __webpack_public_path__ + "828fce2d440215c808981e68fdb6550a-455.png"},
          
          width: 455,
          height: 127
        }